import type { Version } from '@storebrand-digital/fms-translations/dist/types';

import { init } from '@storebrand-digital/fms-translations';

export async function initFMS() {
  await init({
    clientId: window.env.CLIENT_ID,
    documentIds: ['bankSelfServiceWeb'],
    getFallbackTextsForLanguage: async (language) => {
      if (language === 'en') {
        const { default: en } = await import(
          '../fms-fallbacks/fallback-en.json'
        );
        return en;
      }
      const { default: no } = await import('../fms-fallbacks/fallback-no.json');
      return no;
    },
    version: window.env.TRANSLATION_VERSION as Version,
  });
}
